const formRestrictions = {
  photoMaxSize: 'Not smaller than 100x100px and not larger than 3MB.',
};

export default formRestrictions;
